import { styled } from 'styled-components';

import { ButtonGroupWrapper, ButtonsWrapper } from './styles';
import { ButtonGroupProps } from './types';

const ButtonGroup = ({ children, className, alignment = 'flex-end' }: ButtonGroupProps) => {
  return (
    <ButtonGroupWrapper alignment={alignment} className={className}>
      <ButtonsWrapper>{children}</ButtonsWrapper>
    </ButtonGroupWrapper>
  );
};
export default styled(ButtonGroup)``;

export const ButtonGroupWithFullWidth = styled(ButtonGroup)`
  > ${ButtonsWrapper} {
    max-width: 100%;
  }
`;
